export const URL_BASE_BACK = process.env.REACT_APP_API_URL || "https://default-url.com";

export const URL_COMPLEMENT = "/gateway/api/v1";

export const URL_COMPLEMENT_V2 = "/gateway/api/v2";

export const URL_LOGIN = `${URL_BASE_BACK}/gateway/authentication/log-in/`;

export const URL_LOGIN_V2 = `${URL_BASE_BACK}/gateway/api/v2/authentication/log-in/`;

export const URL_LOGOUT = `${URL_BASE_BACK}/gateway/authentication/log-out/`;

export const URL_DASHBOARD = `${URL_BASE_BACK}${URL_COMPLEMENT}/dashboard`;

export const URL_USERS = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_PASSWORD_CREATE = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_TRD = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_TRD_V2 = `${URL_BASE_BACK}${URL_COMPLEMENT_V2}`;

export const URL_FORMS = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_FORMS_V2 = `${URL_BASE_BACK}${URL_COMPLEMENT_V2}`;

export const URL_LIST = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_WORKFLOW = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_WORKFLOW_V2 = `${URL_BASE_BACK}${URL_COMPLEMENT_V2}`;

export const URL_ROLE = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_INTEGRATIONS = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_INTEGRATIONS_V2 = `${URL_BASE_BACK}${URL_COMPLEMENT_V2}`;

export const URL_DOCUMENTARY_TYPES = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_COMPANIES = `${URL_BASE_BACK}${URL_COMPLEMENT}`;

export const URL_COMPANIES_V2 = `${URL_BASE_BACK}${URL_COMPLEMENT_V2}`;

export const URL_IMPORTS = `${URL_BASE_BACK}${URL_COMPLEMENT}`;
